import { createSlice } from '@reduxjs/toolkit';
import { IControlListItem, ISavePartnerOneInfo } from 'src/Common/RTK/interface/ViewFolder';
import { GPSActionApi } from '../services/GPSActionApiSlice';
import { getActionDataApi } from '../services/getActionApi';

interface IGPSActionStateSlice {
  partnerList: ISavePartnerOneInfo[];
  InitialPartnerList: ISavePartnerOneInfo[];
  //Initial control list to compare with current control list to check any changes in control list. It prevents unnecessary API calls while saving the action data.
  InitialControlList: IControlListItem[];
  controlList: IControlListItem[];
}

const initialState: IGPSActionStateSlice = {
  partnerList: [],
  InitialPartnerList: [],
  InitialControlList: [],
  controlList: [],
  
};

export const GPSActionStateSlice = createSlice({
  name: 'GPSActionStateSlice',
  initialState,
  reducers: {
    addPartner: (state, action) => {
      state.partnerList.push(action.payload);
    },
    editPartner: (state, action) => {
      state.partnerList = state.partnerList.map((partner,index) =>
        index === action.payload.editIndex ? action.payload : partner
      );
    },
    removePartner: (state, action) => {
      const partner = state.partnerList[action.payload];
      if(partner.Id){
        //Existing control [If id is not null then it is alreay saved in backend] setting flag to false
        state.partnerList[action.payload].PartnerFlagIsActive = false;
      }else{
        //New control [If id is null then it is added newly and not saved in backend] removaing from list
        state.partnerList = state.partnerList.filter((_,partnerIndex) => partnerIndex !== action.payload);
        state.partnerList[action.payload].PartnerFlagIsActive = false;
      }
    },
    addControl: (state, action) => {
      state.controlList.push(action.payload);
    },
    editControl: (state, action) => {
      state.controlList = state.controlList.map((control,index) =>
        index === action.payload.editIndex ? action.payload : control
      );
    },
    removeControl: (state, action) => {      
      const control = state.controlList[action.payload];
      if(control.Id){
        //Existing control [If id is not null then it is alreay saved in backend] setting flag to false
        state.controlList[action.payload].ControlFlagIsActive = false;
      }else{
        //New control [If id is null then it is added newly and not saved in backend] removaing from list
        state.controlList = state.controlList.filter((_,controlIndex) => controlIndex !== action.payload);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(GPSActionApi.endpoints.getPartnerList.matchFulfilled, (state, action) => {
      state.partnerList = action.payload;
      state.InitialPartnerList = action.payload;
    });
    builder.addMatcher(GPSActionApi.endpoints.getControlList.matchFulfilled, (state, action) => {
      state.controlList = action.payload;
      state.InitialControlList = action.payload;
    });
  },
});

export const { addPartner, editPartner, removePartner, addControl, editControl, removeControl } = GPSActionStateSlice.actions;
